import * as deferredBootstrapper from 'angular-deferred-bootstrap/angular-deferred-bootstrap';
import Translation  from './translation/translation.module';

// Placeholder removal code
window.addEventListener('app-chrome-ready', () => {
    if (window['appContainerPlaceholder']) {
      window['appContainerPlaceholder'].remove();
    }
});

(()=> {
    // Identity client init
    const identityClient: any = window['gafIdentityClientV4'];
    if (!identityClient) {
        console.error('Identity Client V4 Unavailable');
    }

    try{
        let currentIdentityEnvironment;
        const currentHostName = window.location.hostname;

        if (currentHostName.indexOf('.com') !== -1) {
            currentIdentityEnvironment = identityClient.Environments.PRODUCTION;
        } else {
            currentIdentityEnvironment = identityClient.Environments.STAGING;
        }

        identityClient.Initializer.initialize(currentIdentityEnvironment);

    }catch(e) {
        console.error('Error initializing the identity client', e);
    }

    // manifest client init code
    const manifestClient: any = window['miManifestClientV1'];
    if (!manifestClient) {
        console.error("Manifest Client V1 Unavailable");
    }

    try{
        let currentManifestEnvironment;
        const currentHostName = window.location.hostname;

        if (currentHostName.indexOf('.com') !== -1) {
            currentManifestEnvironment = manifestClient.Environments.PRODUCTION;
        } else {
            currentManifestEnvironment = manifestClient.Environments.STAGING;
        }

        manifestClient.Initializer.initialize(currentManifestEnvironment, {});

    }catch(e) {
        console.error('Error initializing the manifest client', e);
    }

})();

try {
    angular.module('MW.AddContentWorkflowBeta');
} catch (e) {
    angular.module('MW.AddContentWorkflowBeta', [])
        .service('AddContentWorkflowService', [function(){}])
}

// bootstrap
angular.element(document).ready(() => {
    deferredBootstrapper.bootstrap({
        element: document,
        module: 'MEDApp',
        injectorModules: Translation,
        resolve: {
            TRANSLATION_CONFIG: ['$q', '$http', 'AppTranslationService', function ($q, $http, AppTranslationService) {
                return AppTranslationService.getUserTranslationData();
            }]
        }
    })
});



/** WEBPACK FOOTER **
 ** ./public/ts/app-bootstrapper.ts
 **/